import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

import { Actions, ofType, createEffect } from '@ngrx/effects';
import * as actions from '../actions/nav.action';

import { tap, map, withLatestFrom } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { getCookiePreferences } from '@teamfoster/sdk/cookie-ngrx';
import { Analyzify } from 'src/app/utility/analyzify.utility';
import { getCart } from 'src/app/shop';

@Injectable()
export class NavEffects {
  constructor(private actions$: Actions, private store: Store) {}

  openCart$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(actions.OpenCart),
        withLatestFrom(this.store.select(getCookiePreferences), this.store.select(getCart)),
        tap(([action, prefs, cart]) => {
          if (prefs?.marketing && cart) {
            Analyzify.ViewCart(cart);
          }
        })
      );
    },
    { dispatch: false }
  );
}
